var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconV3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 76,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-v3_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 37.312,
  cy: 37.782,
  r: 15.015,
  fill: "#5D199D"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.312,
  cy: 37.782,
  r: 16.321,
  stroke: "#fff",
  strokeWidth: 2.611
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M37.58 32.574 33.902 42.6H31.46l-3.677-10.025h2.155l2.757 7.971 2.743-7.97zm1.004 2.313q.072-1.437 1.005-2.212.948-.79 2.485-.79 1.048 0 1.795.373.747.36 1.12.991.388.618.388 1.408 0 .904-.474 1.537-.46.617-1.106.833v.057q.833.258 1.293.92.474.66.474 1.694 0 .862-.402 1.537-.389.675-1.164 1.063-.76.372-1.838.373-1.623 0-2.643-.819-1.02-.818-1.077-2.412h1.953q.03.703.474 1.134.46.417 1.25.417.732 0 1.12-.403.402-.416.402-1.062 0-.863-.546-1.236-.545-.372-1.694-.373h-.417v-1.652h.417q2.04 0 2.04-1.364 0-.617-.374-.962-.36-.345-1.049-.345-.675 0-1.048.373-.36.36-.417.92z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon-v3_svg__a",
  width: 74.471,
  height: 74.471,
  x: 0.076,
  y: 0.546,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9.805
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.440121 0 0 0 0 0.499035 0 0 0 0 0.597803 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20508_13461"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20508_13461",
  result: "shape"
})))));
export { SvgIconV3 as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-v3.3e870929.svg";